import Component from './UserSettings.vue';

export default Component;
